import { Box, withStyles } from '@material-ui/core';

export const MobileFloatMenu = withStyles({
  root: {
    position: 'absolute',
    display: 'flex',
    bottom: 30,
    borderRadius: 120,
    background: 'rgba(51, 61, 71, 0.70)',
    right: '50%',
    transform: 'translate(50%)',
    padding: '0 12px',
    zIndex: 1
  }
})(Box);

export const StyledMenuItem = withStyles(({ spacing }) => ({
  root: {
    position: 'relative',
    marginTop: spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gridGap: '4px',
    width: 'max-content'
  }
}))(Box);

export const ItemBadge = withStyles(({ palette }) => ({
  root: {
    alignSelf: 'baseline',
    minWidth: 20,
    height: 20,
    fontWeight: 600,
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    color: palette.common.white,
    backgroundColor: palette.primary.main
  }
}))(Box);
